import type { TypeDashboardRole, TypeSessionUserStatus } from '@/types/auth/types.auth.session';

export const ROLE_LABEL: Record<TypeDashboardRole, string> = {
    owner: 'Proprietario',
    admin: 'Amministratore',
    operator: 'Operatore',
    viewer: 'In sola lettura',
};

export const ROLE_HINT: Record<TypeDashboardRole, string> = {
    owner: 'Può tutto, compreso cambiare chi amministra.',
    admin: 'Gestisce persone, servizi e configurazione.',
    operator: 'Lavora sui dati: clienti, preventivi, lavori.',
    viewer: 'Guarda e basta: nessuna modifica.',
};

export const USER_STATUS_LABEL: Record<TypeSessionUserStatus, string> = {
    invited: 'Invitato',
    active: 'Attivo',
    suspended: 'Sospeso',
};

export const initialsOf = (firstname: string, lastname: string, email: string): string => {
    const letters = `${firstname.trim()[0] ?? ''}${lastname.trim()[0] ?? ''}`.trim();
    if (letters) return letters.toUpperCase();
    return (email.trim()[0] ?? '—').toUpperCase();
};
